export default {
  users: {
    name: "Name",
    role_id: "Role ID",
    username: "Username",
    password: "Password",
    active: "Active"
  },
  button: {
    back: "Back",
    confirm: "Confirm"
  },
  error: {
    "generic": "Error occured",

    403: "Sorry, you may not have permission to visit this page",
    404: "Sorry, the page you requested is not found",
  },
  field: {
    req_id: "Req ID",
    cp_id: "Cp ID",
    cre_dttm: "Cre Dttm",
    request_type:  "Request Type",
    request_data: "Request Data",
    response_data: "Response Data",
    loc: "location",
    firmware_version: "Firmware Version"
  }
}